import { useContext } from 'react';

import { VoucherContext } from 'components/signUpFunnel/Contexts';

const useUsaa = () => {
  const { voucher, usaaMemberId } = useContext(VoucherContext);

  if (voucher?.isUsaa || usaaMemberId) {
    return true;
  } else {
    return false;
  }
};

export default useUsaa;
